export default __webpack_public_path__ + "static/cd_raw_2-b2bfbf1fe1c932fa8bae00a33ba3286e.jpg";